import React from 'react';
import ReactDOM from 'react-dom/client';
import { loadRuntimeConfig } from './config';
import './brand.css';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

void loadRuntimeConfig().then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
